module.exports = __webpack_public_path__ + "img/symbol_11.ccec9e96.png";